export const tourGuideSteps = [
  {
    selector: "#message-batch-search-filter",
    content:
      "Users can make use of the filtering options to narrow message batch requests.",
  },
  {
    selector: "#message-batch-data-grid",
    content:
      "This data grid contains the list of message batch requests based on the filter parameters above.",
  },
  {
    selector: "#Batches-column-0",
    content:
      "Press the View Batch Details link below to get the full details about the message batch.",
  },
  {
    selector: "#Batches-column-3",
    content:
      "Press the link below to navigate to the client details page.",
  },
  {
    selector: "#Batches-column-4",
    content:
      "Press the link below to navigate to the environment details page.",
  },
  {
    selector: "#Batches-column-5",
    content:
      "Press the link below to navigate to the channel details page.",
  },
];
